'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _slicedToArray = require('@babel/runtime-corejs3/helpers/slicedToArray');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _JSON$stringify = require('@babel/runtime-corejs3/core-js-stable/json/stringify');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _spliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/splice');
require('../utils/index.js');
var sha256 = require('crypto-js/sha256');
var dataSource_interface = require('./data-source.interface.js');
var loadToEdge_model = require('./load-to-edge.model.js');
var loadToEntityLogic_model = require('./load-to-entity-logic.model.js');
var loadToVertex_model = require('./load-to-vertex.model.js');
var dataSet_interface = require('./data-set.interface.js');
var dataSourceLogic_model = require('./data-source-logic.model.js');
var dataSetLogic_model = require('./data-set-logic.model.js');
var helperFunctions = require('../utils/helper-functions.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _JSON$stringify__default = /*#__PURE__*/_interopDefaultLegacy(_JSON$stringify);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _spliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_spliceInstanceProperty);
var sha256__default = /*#__PURE__*/_interopDefaultLegacy(sha256);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context8; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context8 = {}.toString.call(r)).call(_context8, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**
 * The loading job in memory representation.
 *
 * @export
 * @interface LoadingJobData
 */

/**
 * The loading job name prefix for different types of data source.
 *
 * @export
 * @enum {string}
*/
var LoadingJobPrefix = /*#__PURE__*/function (LoadingJobPrefix) {
  LoadingJobPrefix["FILE"] = "file_load_job_";
  LoadingJobPrefix["S3"] = "kafka_s3_load_job_";
  LoadingJobPrefix["GCS"] = "gcs_load_job_";
  LoadingJobPrefix["ABS"] = "abs_load_job_";
  LoadingJobPrefix["OLD_S3"] = "s3_load_job_";
  return LoadingJobPrefix;
}({});

/**
 * Provides APIs to handle loading job related business logic.
 *
 * @export
 * @class LoadingJobLogic
 */
var LoadingJobLogic = /*#__PURE__*/function () {
  function LoadingJobLogic() {
    _classCallCheck__default["default"](this, LoadingJobLogic);
  }
  return _createClass__default["default"](LoadingJobLogic, null, [{
    key: "clone",
    value:
    /**
     * Clone loading job data.
     *
     * @static
     * @param {LoadingJobData} data
     * @returns {LoadingJobData}
     * @memberof LoadingJob
     */
    function clone(data) {
      var result = JSON.parse(_JSON$stringify__default["default"](data));
      return result;
    }

    /**
     * Load information from GSQL loading job json and database json into loading job data.
     * Should do validation check before invoking this function.
     *
     * @static
     * @param {GSQLLoadingJobJson} loadingJobJson
     * @param {DBLoadingJobJson} dbLoadingJobJson
     * @returns {LoadingJobData}
     * @memberof LoadingJobLogic
     */
  }, {
    key: "loadFromGSQLAndDB",
    value: function loadFromGSQLAndDB(gsqlLoadingJobJson, dbLoadingJobJson) {
      // Load information from the DB loading job to the in-memory loading job.
      var dataSource = dataSourceLogic_model.DataSourceLogic.createDataSource(dbLoadingJobJson.dataSourceJson.dataSourceName, dataSourceLogic_model.DataSourceLogic.getDataSourceType(dbLoadingJobJson.dataSourceJson.type));
      var dataFormat;
      var dataSchema;
      var sampleData;
      if (dbLoadingJobJson.header && dbLoadingJobJson.header.length > 0 && dbLoadingJobJson.sampleData && dbLoadingJobJson.sampleData.length > 0) {
        dataFormat = dataSet_interface.DataFormat.CSV;
        dataSchema = dataSetLogic_model.DataSetLogic.createTabularDataSchema(dbLoadingJobJson.header);
        dbLoadingJobJson.dataSetJson = {
          dataFormat: dataSet_interface.DataFormat.CSV,
          dataSchema: []
        };

        // TODO: Deprecate sample data in the future due to user data privacy concern.
        sampleData = dbLoadingJobJson.sampleData;
      } else if (dbLoadingJobJson.dataSetJson) {
        dataFormat = dbLoadingJobJson.dataSetJson.dataFormat;
        dataSchema = dbLoadingJobJson.dataSetJson.dataSchema;
        delete dbLoadingJobJson['header'];
        delete dbLoadingJobJson['sampleData'];
      }
      var dataSet = {
        uri: dbLoadingJobJson.dataSourceJson.uri,
        parsingOptions: dbLoadingJobJson.dataSourceJson.options,
        dataFormat: dataFormat,
        dataSchema: dataSchema,
        position: dbLoadingJobJson.dataSourceJson.position
      };

      // TODO: Deprecate sample data in the future due to user data privacy concern.
      if (sampleData) {
        dataSet['sampleData'] = sampleData;
      }
      var loadingJobData = LoadingJobLogic.createLoadingJob(dbLoadingJobJson.loadingJobName, dataSource, dataSet, []);

      // Load information from the GSQL loading job to the in-memory loading job.
      // If no loading statement in the loading job, then it cannot be saved at GSQL side,
      // in this case all information are loaded from database side
      if (gsqlLoadingJobJson !== undefined) {
        var _context;
        // Load each loading statement
        _forEachInstanceProperty__default["default"](_context = gsqlLoadingJobJson.LoadingStatements).call(_context, function (loadingStatement, i) {
          if (dataFormat === dataSet_interface.DataFormat.JSON) {
            delete loadingStatement.UsingClauses['HEADER'];
            delete loadingStatement.UsingClauses['SEPARATOR'];
          }
          switch (loadingStatement.Type) {
            case 'Vertex':
              {
                loadingJobData.loadingStatements.push(loadToVertex_model.LoadToVertexLogic.loadFromGSQLAndDB(loadingStatement, dbLoadingJobJson.loadingStatementsStyle[i], dataSchema));
                break;
              }
            case 'Edge':
              {
                loadingJobData.loadingStatements.push(loadToEdge_model.LoadToEdgeLogic.loadFromGSQLAndDB(loadingStatement, dbLoadingJobJson.loadingStatementsStyle[i], dbLoadingJobJson.dataSetJson.dataSchema));
                break;
              }
          }
        });
      }

      // Parsing succeed.
      return loadingJobData;
    }

    /**
     * Dump in-memory loading job object into GSQL loading job json and database json.
     * Should not call this function if not passing semantic check.
     * If there is no loading statements, the gsqlLoadingJobJson will be undefined.
     * Thus it won't be saved to GSQL side.
     *
     * @static
     * @param {LoadingJobData} loadingJobData
     * @param {Graph} schema
     * @returns {[GSQLLoadingJobJson, DBLoadingJobJson]}
     * @memberof LoadingJobLogic
     */
  }, {
    key: "dumpToGSQLAndDB",
    value: function dumpToGSQLAndDB(loadingJobData, schema) {
      var _context2, _context3, _context4;
      // Dump information from an in-memory loading job to a DB loading job.
      var dbLoadingJobJson = {
        loadingJobName: loadingJobData.jobName,
        loadingStatementsStyle: [],
        dataSourceJson: {
          type: loadingJobData.dataSource.type,
          dataSourceName: loadingJobData.dataSource.name,
          uri: loadingJobData.dataSet.uri,
          options: loadingJobData.dataSet.parsingOptions,
          position: loadingJobData.dataSet.position
        },
        dataSetJson: {
          dataFormat: loadingJobData.dataSet.dataFormat,
          dataSchema: []
        }
      };
      switch (loadingJobData.dataSet.dataFormat) {
        case dataSet_interface.DataFormat.CSV:
          // TODO: Deprecate them and use data schema in the future.
          dbLoadingJobJson['header'] = _mapInstanceProperty__default["default"](_context2 = loadingJobData.dataSet.dataSchema).call(_context2, function (dataSetSchema) {
            return dataSetSchema.name;
          });
          dbLoadingJobJson['sampleData'] = loadingJobData.dataSet.sampleData;
          break;
        case dataSet_interface.DataFormat.JSON:
          dbLoadingJobJson.dataSetJson.dataSchema = loadingJobData.dataSet.dataSchema;
          break;
        default:
          // TODO: Support more data formats in the future.
          break;
      }

      // Initialize a GSQL loading job.
      var gsqlLoadingJobJson = {
        FileNames: {
          MyDataSource: ''
        },
        Type: 'Offline',
        JobName: loadingJobData.jobName,
        GraphName: schema.name,
        Headers: {},
        Filters: [],
        LoadingStatements: []
      };

      // Collect information from each loading statement
      // [GST-204] In the GSQL 'export job * as json' command, the loading statements always exported
      // following the 'temp table', 'delete vertex', 'delete edge', 'load to vertex', 'load to edge'
      // order, so here before save we also need to adjust the order following the above order.

      // Collect load-to-vertex statements
      _forEachInstanceProperty__default["default"](_context3 = loadingJobData.loadingStatements).call(_context3, function (loadingStatement) {
        // Collect information based on either it's load-to-vertex or load-to-edge
        if ('vertexName' in loadingStatement) {
          var gsqlLoadToEntityJson;
          var dbLoadingStatementStyle;
          var _LoadToVertexLogic$du = loadToVertex_model.LoadToVertexLogic.dumpToGSQLAndDB(loadingStatement, loadingJobData.dataSet.dataFormat, loadingJobData.dataSet.dataSchema);
          var _LoadToVertexLogic$du2 = _slicedToArray__default["default"](_LoadToVertexLogic$du, 2);
          gsqlLoadToEntityJson = _LoadToVertexLogic$du2[0];
          dbLoadingStatementStyle = _LoadToVertexLogic$du2[1];
          gsqlLoadingJobJson.LoadingStatements.push(gsqlLoadToEntityJson);
          dbLoadingJobJson.loadingStatementsStyle.push(dbLoadingStatementStyle);
        }
      });

      // Collect load-to-edge statements
      _forEachInstanceProperty__default["default"](_context4 = loadingJobData.loadingStatements).call(_context4, function (loadingStatement) {
        // Collect information based on either it's load-to-vertex or load-to-edge
        if ('edgeName' in loadingStatement) {
          var gsqlLoadToEntityJson;
          var dbLoadingStatementStyle;
          var _LoadToEdgeLogic$dump = loadToEdge_model.LoadToEdgeLogic.dumpToGSQLAndDB(loadingStatement, loadingJobData.dataSet.dataFormat, loadingJobData.dataSet.dataSchema);
          var _LoadToEdgeLogic$dump2 = _slicedToArray__default["default"](_LoadToEdgeLogic$dump, 2);
          gsqlLoadToEntityJson = _LoadToEdgeLogic$dump2[0];
          dbLoadingStatementStyle = _LoadToEdgeLogic$dump2[1];
          gsqlLoadingJobJson.LoadingStatements.push(gsqlLoadToEntityJson);
          dbLoadingJobJson.loadingStatementsStyle.push(dbLoadingStatementStyle);
        }
      });

      // If no loading statements, make GSQL loading statements undefined.
      if (gsqlLoadingJobJson.LoadingStatements.length === 0) {
        gsqlLoadingJobJson = undefined;
      }
      return [gsqlLoadingJobJson, dbLoadingJobJson];
    }

    /**
     * Check if the GSQL loading job json is valid json, i.e., not containing unsupported features.
     *
     * @static
     * @param {GSQLLoadingJobJson} loadingJobJson
     * @param {DBLoadingJobJson} dbLoadingJobJson
     * @returns {{
     *     success: boolean,
     *     message?: string
     *   }}
     * @memberof LoadingJobLogic
     */
  }, {
    key: "validationCheck",
    value: function validationCheck(loadingJobJson, dbLoadingJobJson) {
      // 1. Offline loading job is not supported.
      if (loadingJobJson.Type === 'Online') {
        return {
          success: false,
          message: 'Online post job is deprecated in Graph Studio.'
        };
      }

      // 2. User defined inline filter is not supported.
      if (loadingJobJson.Filters.length > 0) {
        return {
          success: false,
          message: 'User defined inline filters is not supported in Graph Studio.'
        };
      }

      // 3. User defined header is not supported. Need use SrcColIndex directly
      if (_Object$keys__default["default"](loadingJobJson.Headers).length > 0) {
        return {
          success: false,
          message: 'User defined header is not supported in Graph Studio.'
        };
      }

      // 4. Validation check each loading statement.
      var i = 0;
      var _iterator = _createForOfIteratorHelper(loadingJobJson.LoadingStatements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var loadingStatement = _step.value;
          // Do validation check based on each loading statement type.
          switch (loadingStatement.Type) {
            // Load to temp table, delete vertex | edge is not supported for now.
            case 'TempTable':
              {
                return {
                  success: false,
                  message: 'Load to temp table is not supported in Graph Studio.'
                };
              }
            case 'DeleteVertex':
              {
                return {
                  success: false,
                  message: 'Delete vertex is not supported in Graph Studio.'
                };
              }
            case 'DeleteEdge':
              {
                return {
                  success: false,
                  message: 'Delete edge is not supported in Graph Studio.'
                };
              }
            // Recursively validation check load to vertex
            case 'Vertex':
              {
                var validationCheckLoadToVertex = loadToEntityLogic_model.LoadToEntityLogic.validationCheck(loadingStatement);
                if (!validationCheckLoadToVertex.success) {
                  return validationCheckLoadToVertex;
                }
                break;
              }
            // Recursively validation check load to edge
            case 'Edge':
              {
                var validationCheckLoadToEdge = loadToEntityLogic_model.LoadToEntityLogic.validationCheck(loadingStatement);
                if (!validationCheckLoadToEdge.success) {
                  return validationCheckLoadToEdge;
                }
                break;
              }
            default:
              {
                return {
                  success: false,
                  message: "\"".concat(loadingStatement.Type, "\" is invalid loading statement type.")
                };
              }
          }
          i++;
        }

        // 5. GSQL loading statement number and DB loading statement number don't match
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (loadingJobJson.LoadingStatements.length !== dbLoadingJobJson.loadingStatementsStyle.length) {
        return {
          success: false,
          message: 'Loading statement number saved in engine and backend side don\'t match.'
        };
      }
      return {
        success: true
      };
    }

    /**
     * Check if the in-memory loading job statements have any semantic errors.
     * The error message are collected in the message string array.
     * If one loading statement doesn't have any errors, the message will be empty.
     * NOTE: Must invoke this semantic check after converting job GSQL representation to in-memory
     *       loading jobs and before convert the in-memory loading jobs back to GSQL representation.
     *
     * @static
     * @param {LoadingJobData} loadingJob
     * @param {Graph} schema
     * @returns {{
     *     success: boolean,
     *     message: string[]
     *   }}
     * @memberof LoadingJobLogic
     */
  }, {
    key: "semanticCheck",
    value: function semanticCheck(loadingJob, schema) {
      var _context5;
      // Collect semantic check result of each loading statements
      var result = {
        success: true,
        message: []
      };

      // Collect semantic check errors of each loading statement.
      _forEachInstanceProperty__default["default"](_context5 = loadingJob.loadingStatements).call(_context5, function (loadingStatement) {
        var dataSchema = loadingJob.dataSet.dataSchema;
        var loadingStmtSemanticCheck;
        if ('vertexName' in loadingStatement) {
          // Semantic check as LoadToVertex
          loadingStmtSemanticCheck = loadToVertex_model.LoadToVertexLogic.semanticCheck(loadingStatement, _mapInstanceProperty__default["default"](dataSchema).call(dataSchema, function (dataField) {
            return dataField.name;
          }), schema);
        } else {
          // Semantic check as LoadToEdge
          loadingStmtSemanticCheck = loadToEdge_model.LoadToEdgeLogic.semanticCheck(loadingStatement, _mapInstanceProperty__default["default"](dataSchema).call(dataSchema, function (dataField) {
            return dataField.name;
          }), schema);
        }
        result.success = result.success && loadingStmtSemanticCheck.success;
        result.message.push(loadingStmtSemanticCheck.message);
      });
      return result;
    }

    /**
     * Create one empty loading job given data source information.
     *
     * @static
     * @param {string} jobName
     * @param {DataSource} dataSource
     * @param {DataSet} dataSet
     * @param {(LoadToVertexData | LoadToEdgeData)[]} loadingStatements
     * @returns {LoadingJobData}
     * @memberof LoadingJobLogic
     */
  }, {
    key: "createLoadingJob",
    value: function createLoadingJob(jobName, dataSource, dataSet, loadingStatements) {
      return {
        jobName: jobName,
        dataSource: dataSource,
        dataSet: dataSet,
        loadingStatements: loadingStatements
      };
    }

    /**
     * Get loading job name.
     *
     * @param {DataSourceType} dataSourceType
     * @param {string} uri
     * @returns {string}
     */
  }, {
    key: "createLoadingJobName",
    value: function createLoadingJobName(dataSourceType, uri) {
      var _context6;
      var jobNamePrefix = '';
      switch (dataSourceType) {
        case dataSource_interface.DataSourceType.File:
          jobNamePrefix = LoadingJobPrefix.FILE;
          break;
        case dataSource_interface.DataSourceType.S3:
          jobNamePrefix = LoadingJobPrefix.S3;
          break;
        case dataSource_interface.DataSourceType.GoogleCloudStorage:
          jobNamePrefix = LoadingJobPrefix.GCS;
          break;
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          jobNamePrefix = LoadingJobPrefix.ABS;
          break;
        default:
          // TODO: Support more data source types.
          break;
      }
      return jobNamePrefix + _sliceInstanceProperty__default["default"](_context6 = sha256__default["default"](helperFunctions.HelperFunctions.fileNameToId(uri) + '_' + new Date().getTime()).toString()).call(_context6, 0, 10);
    }

    /**
     * Delete the loading statement with the given id.
     *
     * @static
     * @param {LoadingJobData} loadingJobData
     * @param {number} statementIndex
     * @memberof LoadingJobLogic
     */
  }, {
    key: "removeLoadingStatement",
    value: function removeLoadingStatement(loadingJobData, statementIndex) {
      var _context7;
      _spliceInstanceProperty__default["default"](_context7 = loadingJobData.loadingStatements).call(_context7, statementIndex, 1);
    }
  }]);
}();

exports.LoadingJobLogic = LoadingJobLogic;
exports.LoadingJobPrefix = LoadingJobPrefix;
